export enum Filters {
    ACTIVITY = "activity",
    AGE_CATEGORY = "ageCategory",
    CCS0 = "ccs0",
    DIAGNOSIS = "diagnosis",
    DIAGNOSIS_GROUP = "diagnosisGroup",
    SELECTED_DIAGNOSIS_GROUP = "selectedDiagnosisGroup",
    GENDER = "gender",
    INSURER = "insurer",
    IS_CHRONIC = "isChronic",
    COMORBIDITY_INDEX = "comorbidityIndex",
    IS_FRAIL_ELDERLY = "isFrailElderly",
    IS_NEW = "isNew",
    IS_COMPLEX = "isComplex",
    REFERRER_TYPE = "referrerType",
    MUNICIPALITY = "municipality",
    CARE_CLUSTER = "zorgcluster",
    SOCIAL_STATUS = "socialStatus",
    SPECIALISM = "specialism",
    SELECTED_SPECIALISM = "selectedSpecialism",
    MULTIDISCIPLINARY_SPECIALISM = "multidisciplinarySpecialism",
    URGENCY_CARE = "urgencyCare",
    AC1 = "ac1",
    AC2 = "ac2",
    AC3 = "ac3",
    TRC1 = "trc1",
    TRC2 = "trc2",
    TRC3 = "trc3",
    RVE = "rve",
    HOSPITAL_AREA = "hospitalArea",
    PANDEMIC_CARE = "pandemicCare",
    DIFF_COST = "diffCost",
    SPECIALISM_DIFF_COST = "specialismDiffCost",
    PATIENT_VOLUME = "patientVolume",
    FLAG = "flag",
    IS_REFERRED = "isReferred",
    ZE_GG = "zegg",
    LOCATION = "location"
}

export enum OuterFilters {
    BEST_PRACTICE = "best-practice",
    KPI = "kpi"
}
